import {createAsyncThunk} from '@reduxjs/toolkit'

import {BENEFIT_POLICY_INFO_MOBILE_URL, BENEFIT_POLICY_INFO_URL} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/**
 * 구매적립 혜택정책 안내 페이지로 이동
 */
const navigateToBenefitPolicyInfo = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi>(
    'navigateTo/benefitPolicy',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}
        const shouldChangeLocation = forceLocationChange || isMobile

        if (shouldChangeLocation) {
            changeBrowserLocation({url: BENEFIT_POLICY_INFO_MOBILE_URL, type: 'PUSH'})
            // page 이동은 그 자체로 추가동작 없이 resolve 된다
            return Promise.resolve()
        }

        openNewTab({url: BENEFIT_POLICY_INFO_URL})
        return Promise.resolve()
    },
)

export default navigateToBenefitPolicyInfo
